module.exports = __webpack_public_path__ + "images/40a836122caaf9af4e96b0d50a8daf0e2.svg";